import { useMemo } from "react";

// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Row } from "@crehana/ui";
import { excludeFooterLinksByLabel } from "../utils/excludeFooterLinksByLabel";
import AppsColumn from "../components/AppsColumn";
import LinksColumn from "../components/LinksColumn";
import { COMPANY_LINKS, HELP_LINKS, PRODUCT_LINKS, RESOURCES_LINKS } from "../constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var TopSection = function TopSection(_ref) {
  var isDark = _ref.isDark,
    _ref$shouldHideWeAreH = _ref.shouldHideWeAreHiringLink,
    shouldHideWeAreHiringLink = _ref$shouldHideWeAreH === void 0 ? false : _ref$shouldHideWeAreH,
    _ref$shouldHideSignUp = _ref.shouldHideSignUpLink,
    shouldHideSignUpLink = _ref$shouldHideSignUp === void 0 ? false : _ref$shouldHideSignUp,
    _ref$shouldHideResour = _ref.shouldHideResourceSection,
    shouldHideResourceSection = _ref$shouldHideResour === void 0 ? false : _ref$shouldHideResour,
    _ref$shouldHideAppsCo = _ref.shouldHideAppsColumn,
    shouldHideAppsColumn = _ref$shouldHideAppsCo === void 0 ? false : _ref$shouldHideAppsCo;
  var COMPANY_LINKS_FILTERED = useMemo(function () {
    return excludeFooterLinksByLabel(COMPANY_LINKS, [shouldHideWeAreHiringLink ? 'COMPANY_HIRING' : undefined, shouldHideSignUpLink ? 'COMPANY_SIGN_UP' : undefined]);
  }, [shouldHideWeAreHiringLink, shouldHideSignUpLink]);
  return /*#__PURE__*/_jsxs(Row, {
    className: "tw-py-3.2 sm:tw-pt-4.8 lg:tw-pt-6.4 md:tw-mb-1.6 lg:tw-mb-6.4 md:tw-justify-around",
    children: [COMPANY_LINKS_FILTERED.length > 0 && /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "COMPANY_TITLE",
      links: COMPANY_LINKS_FILTERED
    }), /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "PRODUCT_TITLE",
      links: PRODUCT_LINKS
    }), !shouldHideResourceSection && /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "RESOURCES_TITLE",
      links: RESOURCES_LINKS
    }), /*#__PURE__*/_jsx(LinksColumn, {
      isDark: isDark,
      title: "HELP_TITLE",
      links: HELP_LINKS
    }), !shouldHideAppsColumn && /*#__PURE__*/_jsx(AppsColumn, {
      isDark: isDark,
      className: "tw-hidden md:tw-block"
    })]
  });
};
export default TopSection;